import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { Observable, throwError } from 'rxjs';
import { callbackErrorFailure } from './auth0-callback-error';
import { CallbackErrorAwareAuthService } from './callback-error-aware-auth.service';

/**
 * Bug 37976 (review of PR 8235, code-hr): auth0-angular 1.11.1's AuthHttpInterceptor calls
 * `auth0Client.getTokenSilently` itself (it injects the client, never AuthService), so the AuthService hold does not
 * reach it. While a refused-login callback error stands, this fails each authed request at once with that error
 * instead of running a silent /authorize (or refresh-token POST) against the refused session; otherwise it hands the
 * request to auth0-angular's interceptor unchanged.
 */
@Injectable()
export class CallbackErrorAwareAuthHttpInterceptor implements HttpInterceptor {
  private readonly auth = inject(CallbackErrorAwareAuthService);
  private readonly inner = inject(AuthHttpInterceptor);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const held = this.auth.callbackError();
    if (held) return throwError(() => callbackErrorFailure(held));
    return this.inner.intercept(req, next);
  }
}
